const UploadCloud = ({ size=20, color="#000000", ...props }) => (
    <svg
        height={size}
        width={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round" 
        strokeLinejoin="round"
    >
        <path d="M12 13v8"/>
        <path d="M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"/>
        <path d="m8 17 4-4 4 4"/>
    </svg>
);

export default UploadCloud;
